module.exports = global["jQuery"] = require("-!D:\\a\\1\\s\\LudvigSvensson.Web\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");